﻿export class WarehouseDocumentRow {
    customsProcedureDate = null;
}
